import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Paper,
  Button,
  Stack,
  Box
} from "@mui/material";
import { collection, query, where, onSnapshot, doc, updateDoc } from "firebase/firestore";
import { db } from "./firebase";
import { useNavigate } from "react-router-dom";


const ApprovalDashboard = () => {
  const [orders, setOrders] = useState([]);
const navigate = useNavigate();
  useEffect(() => {
    const q = query(
      collection(db, "orders"),
      where("status", "==", "عند برهان - بانتظار المقارنة")
    );

    const unsub = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      setOrders(data);
    });

    return () => unsub();
  }, []);

  const handleApprove = async (order) => {
    const ref = doc(db, "orders", order.id);

    await updateDoc(ref, {
      status: "comparisonApproved",
      history: [
        ...(order.history || []),
        {
          status: "تمت الموافقة",
          by: "بنين",
          timestamp: new Date()
        }
      ]
    });
  };

  const handleReject = async (order) => {
    const ref = doc(db, "orders", order.id);

    await updateDoc(ref, {
      status: "عند برهان",
      completedSteps: [],
      history: [
        ...(order.history || []),
        {
          status: "تم الرفض - إعادة للطباعة",
          by: "بنين",
          timestamp: new Date()
        }
      ]
    });
  };

  return (
    <Container sx={{ mt: 5 }}>
      <Typography variant="h5" gutterBottom>
        ✅ واجهة الموافقات - بنين
      </Typography>

      {orders.map((order) => (
        <Paper key={order.id} sx={{ p: 3, mb: 2 }}>
          <Typography>👤 {order.customerName}</Typography>
          <Typography>🌍 {order.governorate}</Typography>
<Button
  variant="contained"
  fullWidth
  onClick={() => navigate(`/compare-boards/${order.id}?from=approval`)}
>
  🔍 فتح الطلب واتخاذ القرار
</Button>
         
        </Paper>
      ))}
    </Container>
  );
};

export default ApprovalDashboard;